<template>
  <div>
    <div class="navi-home" v-if="homeVisible">
      <div class="navi-top">
        <div class="inject-home">
          <!-- 紀錄btn -->
          <a-button
            type="primary"
            block
            @click="()=> recordStuts = !recordStuts"
          >{{recordStuts ? $t('edit.guide.stopRecord') : $t('edit.guide.startRecord')}}</a-button>
          <div v-show="recordStuts" style="padding-top: 10px;">
          <!-- <a-button block type="danger" @click="deleAllPoint">
            - {{$t('edit.guide.deleAllGuide')}}
          </a-button> -->
        </div>
        </div>

        <div style="margin:0 20px">{{$t('edit.guide.currentGuides')}}</div>
      </div>

      <div class="navi-bottom">
        <div>
          <ListItem
                  v-for="(value, index) in guideObj.points"
                  :key="index"
                  :index="index+1"
                  :isFirst="index === 0"
                  :listData="value"
                  :selected="selectedItem"
                  :inputShow="recordStuts"
                  :checked="value.isChecked"
                  @toSettingPoint="toSetting"
                  @renameItem="renameItem"
                  @deleteItem="deleteItem"
                  @selectedCell="clickGuideItem(value)"
                  @change="choseItem"
          ></ListItem>
        </div>

        <!-- 添加路徑btn -->
        <div v-show="recordStuts">
          <a-button block type="primary" ghost @click="addPoint">
            + {{$t('edit.guide.addGuide')}}
          </a-button>
        </div>
        <div v-show="recordStuts" style="padding-top: 10px;">
          <a-button block ghost @click="deleHandlePoint" class="deleHandleBtn">
            - {{$t('edit.guide.deleSelectedItems')}}
          </a-button>
        </div>
        <div v-show="recordStuts" style="padding-top: 10px;">
          <a-button block type="danger" @click="deleAllPoint">
            - {{$t('edit.guide.deleAllGuide')}}
          </a-button>
        </div>
      </div>
    </div>
    <NaviSetting
      v-if="settingVisible"
      @clickBack="clickBack"
      :targetObj="renameObj"
      @saveChangeData="saveChangeData"
    ></NaviSetting>
    <!--重命名-->
    <a-modal v-model="renameVisible" :title="$t('actionTitles.rename')" :destroyOnClose="true" @ok="handleConfirm">
      <div>
        <div>
          <a-input v-model="newName" :addonBefore="$t('edit.guide.guideName.label')" :placeholder="renameObj.title"></a-input>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import ImgItem from "../hotpoint/ImgItem.vue";
import NaviSetting from "./NaviSetting";
import ListItem from "./ListItem.vue";
import { v4 as uuidv4 } from "uuid";

export default {
  components: {
    // ImgItem,
    NaviSetting,
    ListItem,
  },
  data() {
    return {
      selectedItem: {},
      sceneList: [],
      homeVisible: true,
      settingVisible: false,
      recordStuts: false,
      renameVisible: false,
      newName: "",
      renameObj: {},
      guideObj: {},
      choseList:[],
    };
  },
  computed: {
    ...mapGetters(["vrbase", "currentScenesId", "editGuide", "userInfo"]),
  },
  created() {
    this.guideObj = this.$deepClone(this.editGuide);
    this.guideObj = this.editGuide;
    this.guideObj.points.forEach(function(point) {
            point.isChecked = false;
          });
    console.log("this.guideObj.points:", this.guideObj.points);
  },
  methods: {
    choseItem(checked, label, item){
      if (checked) {
          this.choseList.push(label)
        } else {
          const index = this.choseList.indexOf(label)
          if (index !== -1) {
            this.choseList.splice(index, 1)
          }
        }
        item.isChecked = !item.isChecked
        // console.log(item);
    },
    deleHandlePoint(){
      const _this = this;
      this.$confirm({
        title: _this.$t('edit.editMessage.title'),
        content: _this.$t('edit.editMessage.content'),
        okText: _this.$t('edit.editMessage.okText'),
        okType: "danger",
        cancelText: _this.$t('edit.editMessage.cancelText'),
        onOk() {
          // console.log(_this.choseList);
          for (let i = _this.guideObj.points.length - 1; i >= 0; i--) {
            const point = _this.guideObj.points[i];
            if (_this.choseList.includes(point.index)) {
              removeGuidePoint(point.point_id);
              _this.$delete(_this.guideObj.points, i);
            }
          }
          _this.guideObj.points.forEach(function(point) {
            point.isChecked = false;
          });
          _this.updateStoreGuide();
          _this.reSetIndex();
          _this.choseList = [];
        },
        onCancel() {
          console.log("取消");
        },
      });
    },
    deleAllPoint(){
      const _this = this;
      this.$confirm({
        title: _this.$t('edit.editMessage.title'),
        content: _this.$t('edit.editMessage.content'),
        okText: _this.$t('edit.editMessage.okText'),
        okType: "danger",
        cancelText: _this.$t('edit.editMessage.cancelText'),
        onOk() {
          _this.deleAllGuide();
        },
        onCancel() {
          console.log("取消");
        },
      });
    },
    deleAllGuide(){
      remoceAllGuidePoint(this.guideObj.points);
      this.guideObj.points = [];
    },
    clickGuideItem(value) {
      this.selectedItem = value;
      const sceneId = value.scene_id;
      if (this.currentScenesId != sceneId) {
        this.$store.dispatch("loadScene", sceneId);
      }
      lookto(value.ath, value.atv, value.fov);
    },
    clickBack() {
      this.settingVisible = false;
      this.homeVisible = true;
    },
    renameItem(item) {
      // console.log("renameItem=", item);
      this.renameObj = item;
      this.renameVisible = true;
    },
    deleteItem(item) {
      const _this = this;
      this.$confirm({
        title: _this.$t('edit.editMessage.title'),
        content: _this.$t('edit.editMessage.content'),
        okText: _this.$t('edit.editMessage.okText'),
        okType: "danger",
        cancelText: _this.$t('edit.editMessage.cancelText'),
        onOk() {
          _this.handleDelete(item);
        },
        onCancel() {
          console.log("取消");
        },
      });
    },
    handleDelete(item) {
      removeGuidePoint(item.point_id);
      const index = this.getTargetObjIndex(item);
      // console.log(index);
      if (index > -1) {
        this.$delete(this.guideObj.points, index);
        this.updateStoreGuide();
        this.reSetIndex();
      }
    },
    toSetting(item) {
      this.renameObj = item;
      this.settingVisible = true;
      this.homeVisible = false;
    },
    addPoint() {
      const currIndex = this.guideObj.points.length;
      let viewAt = getSceneViewAt();
      const sampleObj = {
        point_id: "point_" + uuidv4().replace(/-/g, ""),
        scene_id: this.currentScenesId,
        index: currIndex + 1,
        title: this.$t('edit.guide.guideName.defaultName'),
        ath: viewAt.hlookat,
        atv: viewAt.vlookat,
        fov: viewAt.fov,
        move_time: "5",
        music_url: "",
        music_title: "",
        content: "",
      };

      this.$set(this.guideObj.points, currIndex, sampleObj);

      // this.$store.dispatch("setVRBase", this.vrbase);
      this.updateStoreGuide();
      this.setGuidePoint(sampleObj);
    },

    // 添加新路徑
    setGuidePoint(point) {

      //krpano 刪除導覽 function
      removeGuidePoint(point.point_id);

      //krpano 導覽 function
      addGuidePoint({
        point_id: point.point_id,
        ath: point.ath,
        atv: point.atv,
        index: point.index,
      });
    },
    updateStoreGuide() {
      // this.vrbase.guide[0] = this.guideObj;
      this.$set(this.vrbase.guide, 0, this.guideObj);
      this.$store.dispatch("setVRBase", this.vrbase);
    },
    // 重新設置每個的index
    reSetIndex() {
      for (let i = 0; i < this.guideObj.points.length; i++) {
        const item = this.guideObj.points[i];
        item.index = i + 1;
        this.setGuidePoint(item);
      }
    },
    handleConfirm() {
      if (this.newName === "") return;
      // this.guideObj.points[
      this.$set(this.renameObj, "title", this.newName);
      // this.vrbase.guide[0] = this.guideObj;
      // this.$store.dispatch("setVRBase",  this.vrbase);
      this.updateStoreGuide();
      this.renameVisible = false;
      // reset data
      this.newName = "";
      this.renameObj = {};
    },
    // 獲取數組中對象的位置
    getTargetObjIndex(obj) {
      let index = -1;
      for (let i = 0; i < this.guideObj.points.length; i++) {
        const item = this.guideObj.points[i];
        if (obj.point_id === item.point_id) {
          index = i;
        }
      }
      return index;
    },
    saveChangeData(changeData) {
      const index = this.getTargetObjIndex(changeData);
      if (index > -1) {
        this.$set(this.guideObj.points, index, changeData);
        // this.vrbase.guide[0] = this.guideObj;
        // this.$store.dispatch("setVRBase", this.vrbase);
        this.updateStoreGuide();
        this.clickBack(); //close
      }
    },
  },
};
</script>

<style lang="less" scoped>
.navi-home {
  .navi-top {
    position: absolute;
    width: 100%;
    top: 0;
    right: 0;
    left: 0;
    height: 100px;
    overflow: hidden;
    .recordBtn {
      background-color: #7101ad;
      border-color: #7101ad;
    }
  }
  .navi-bottom {
    width: 100%;
    padding: 20px;
    position: absolute;
    top: 100px;
    bottom: 0;
    right: 0;
    left: 0;
    .guideBtn {
      border-color: #d485ff;
      color: #d485ff;
    }
  }
}
  .deleHandleBtn:hover {
    color: #fd898b;
    background-color: #fff;
    border-color: #fc7476;
  }
  .deleHandleBtn {
    color: #ff4d4f;
    background: transparent !important;
    border-color: #ff4d4f;
  }
</style>
